import React from 'react';
import { getHacData } from '../../../../api/hacApi';

export function useCalendarMemberDetails(memberId, token) {
  const [state, setState] = React.useState({ data: null, isLoading: false, hasError: false });

  React.useEffect(() => {
    if (!memberId || !token) {
      setState({ data: null, isLoading: false, hasError: false });
      return undefined;
    }
    let active = true;
    setState({ data: null, isLoading: true, hasError: false });
    getHacData(token, memberId)
      .then((response) => active && setState({ data: response?.data ?? null, isLoading: false, hasError: false }))
      .catch(() => active && setState({ data: null, isLoading: false, hasError: true }));
    return () => { active = false; };
  }, [memberId, token]);

  return state;
}
